import type { SxProps, Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    divider: {
      marginBottom: theme.spacing(8),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(9),
      },
    },
    list: {
      padding: 0,
    },
    item: {
      paddingBottom: 0,
      paddingTop: 0,
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      minWidth: theme.spacing(10),
      margin: `${theme.spacing(6)} 0`,
      [theme.breakpoints.up('lg')]: {
        margin: `${theme.spacing(9)} 0`,
        minWidth: theme.spacing(12),
      },
      '&:first-of-type': {
        marginTop: 0,
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
    avatar: {
      marginRight: theme.spacing(4),
      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(5),
      },
      [theme.breakpoints.up('lg')]: {
        marginRight: theme.spacing(6),
      },
      svg: {
        width: theme.spacing(4),
        [theme.breakpoints.up('lg')]: {
          width: theme.spacing(5),
        },
        height: 'auto',
      },
    },
    avatarHover: {
      '& .MuiChip-outlined': {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.secondary.contrastText,
      },
    },
  };
};
